module.exports = __webpack_public_path__ + "img/csr1.59869c48.jpg";